"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIME_TYPES = void 0;
// This is derived from the mime-db Apache types list but pared down to those we are likely to need and simplified
// to only the abbreviation we want to see on icons or in file names when we generate new files names.
// https://github.com/jshttp/mime-db/blob/master/src/apache-types.json
exports.MIME_TYPES = {
    'application/msword': 'doc',
    'application/pdf': 'pdf',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.ms-excel.sheet.binary.macroenabled.12': 'xlsb',
    'application/vnd.ms-excel.sheet.macroenabled.12': 'xlsm',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.ms-powerpoint.presentation.macroenabled.12': 'pptm',
    'application/vnd.ms-word.document.macroenabled.12': 'docm',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/x-rar-compressed': 'rar',
    'application/zip': 'zip',
    'audio/mp4': 'm4a',
    'audio/mpeg': 'mp3',
    'audio/x-flac': 'flac',
    'audio/x-ms-wma': 'wma',
    'image/bmp': 'bmp',
    'image/gif': 'gif',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'text/plain': 'txt',
    'video/mp4': 'mp4',
    'video/quicktime': 'mov',
    'video/x-matroska': 'mkv',
    'video/x-ms-wmv': 'wmv',
    'video/x-msvideo': 'avi',
};
//# sourceMappingURL=mimeTypes.js.map